document.addEventListener("DOMContentLoaded", function () {
  // const environment = "https://q-community-craft.ddev.site";
  const environment = "https://q.health.org.uk";

  const MPOuterHeader = document.getElementById("MPOuterHeader");
  const MPOuter = document.getElementById("MPOuter");
  const MPOuterFooter = document.getElementById("MPOuterFooter");

  const siteSwitcherFrameDesktopHeight = 40;
  const siteSwitcherFrameMobileHeight = 36

  const siteSwitcherFrame = document.createElement("iframe");
  siteSwitcherFrame.id = "siteSwitcherFrame";
  siteSwitcherFrame.src = environment + "/embeds/site-switcher";
  siteSwitcherFrame.width = "100%";
  siteSwitcherFrame.height = siteSwitcherFrameDesktopHeight;
  siteSwitcherFrame.border = "none";
  siteSwitcherFrame.style.border = "none";

  const siteFooterFrameDesktopHeight = 422;
  const siteFooterFrameMobileHeight = 540; // This is actually kinda dynamic and we could use https://iframe-resizer.com/

  const siteFooterFrame = document.createElement("iframe");
  siteFooterFrame.id = "siteFooterFrame";
  siteFooterFrame.src = environment + "/embeds/site-footer";
  siteFooterFrame.width = "100%";
  siteFooterFrame.height = siteFooterFrameDesktopHeight;
  siteFooterFrame.border = "none";
  siteFooterFrame.style.border = "none";

  if (MPOuterHeader && MPOuter && MPOuterFooter) {
    MPOuterHeader.parentNode.insertBefore(
      siteSwitcherFrame,
      MPOuterHeader
    );

    MPOuterFooter.style.display = "none";
    MPOuterFooter.parentNode.insertBefore(
      siteFooterFrame,
      MPOuterFooter.nextSibling
    );

    function resizeEmbeds() {
      if (window.innerWidth >= 640) {
        siteSwitcherFrame.height = siteSwitcherFrameDesktopHeight;
        siteFooterFrame.height = siteFooterFrameDesktopHeight;
      } else {
        siteSwitcherFrame.height = siteSwitcherFrameMobileHeight;
        siteFooterFrame.height = siteFooterFrameMobileHeight;
      }
    }

    resizeEmbeds();

    window.addEventListener("resize", resizeEmbeds);
  }
});